import type { FC } from "react";

import { cn } from "@/ui/lib/utils";
import { Section } from "@/ui/components/layout/Section";
import { Container } from "@/ui/components/layout/Container";
import { Illustration } from "@/ui/components/primitives/Illustration";
import {
  ANIMATED_HORIZONTAL_RULE_DEFAULTS,
  ANIMATED_HORIZONTAL_RULE_LINE_IMAGE,
  ANIMATED_HORIZONTAL_RULE_LINE_IMAGE_CLASS,
  TAnimatedHorizontalRuleProps,
} from "@/ui/components/layout/AnimatedHorizontalRule";

export const AnimatedHorizontalRule: FC<TAnimatedHorizontalRuleProps> = (
  {
    illustration,
    background,
    className,
    ...props
  },
) => {
  const resolvedBackground = {
    ...ANIMATED_HORIZONTAL_RULE_DEFAULTS.background,
    ...background,
  };

  return (
    <Section
      {...props}
      data-component="AnimatedHorizontalRule"
      className={cn(
        "relative overflow-hidden",
        className,
      )}
    >
      <div
        data-component="AnimatedHorizontalRuleTop"
        className={cn(
          "absolute left-0 top-0 h-1/2 w-full",
          resolvedBackground.top,
        )}
      />
      <div
        data-component="AnimatedHorizontalRuleBottom"
        className={cn(
          "absolute bottom-0 left-0 h-1/2 w-full",
          resolvedBackground.bottom,
        )}
      />
      <div
        data-component="AnimatedHorizontalRuleLine"
        data-image={ANIMATED_HORIZONTAL_RULE_LINE_IMAGE}
        className={cn(
          "absolute inset-0 h-full w-full bg-repeat-x bg-center",
          ANIMATED_HORIZONTAL_RULE_LINE_IMAGE_CLASS,
        )}
      />
      <Container
        data-component="AnimatedHorizontalRuleSpacer"
        aria-hidden="true"
        className="invisible pointer-events-none"
      >
        <Illustration illustration={illustration} />
      </Container>
      <Container className="absolute left-1/2 top-1/2 z-10 w-full -translate-x-1/2 -translate-y-1/2">
        <Illustration illustration={illustration} />
      </Container>
    </Section>
  );
};

AnimatedHorizontalRule.displayName = "AnimatedHorizontalRule";
